module.exports = __webpack_public_path__ + "static/media/details-2-iphone.bda98133.png";